import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <div className="py-24 bg-white overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
                <div className="flex flex-col lg:flex-row items-center gap-20">
                    <div className="lg:w-1/2 relative group">
                        <div className="relative rounded-[3rem] overflow-hidden shadow-2xl transform group-hover:scale-[1.01] transition-all duration-700">
                            <img 
                                src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2070&auto=format&fit=crop" 
                                className="w-full h-[600px] object-cover" 
                                alt="Scenic lake and mountains"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-slate-900/10 to-transparent"></div>
                        </div>
                        <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-amber-500/10 rounded-[4rem] -z-10 animate-pulse hidden lg:block"></div>
                        <div className="absolute top-10 -right-10 w-40 h-40 bg-slate-900/5 rounded-full -z-10 hidden lg:block"></div>
                    </div>
                    
                    <div className="lg:w-1/2 text-left">
                        <div className="flex items-center space-x-4 mb-6">
                            <div className="w-12 h-[2px] bg-amber-500 rounded-full"></div>
                            <h4 className="text-xs font-black tracking-[0.3em] text-amber-500 uppercase">Crafting Experiences</h4>
                        </div>
                        <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-10 tracking-tight leading-[1.1]">
                            Your Journey, Our <span className="text-amber-500">Passion</span>
                        </h2>
                        <div className="space-y-6 text-slate-500 text-lg font-medium leading-relaxed">
                            <p>
                                At GypsyTravels, we don't just book trips; we create lifelong memories. With over a decade of expertise in curating bespoke travel experiences, our team of world-travelers is dedicated to uncovering the world's most hidden gems for you.
                            </p>
                            <p>
                                Whether you're seeking a serene escape in the Swiss Alps or a vibrant cultural immersion in Kyoto, we provide the localized knowledge and premium support to make every moment seamless.
                            </p>
                        </div>
                        
                        <div className="mt-12">
                            <Link to="/tours">
                                <button className="bg-slate-900 hover:bg-amber-500 text-white hover:text-slate-900 font-black py-5 px-12 rounded-2xl shadow-xl hover:shadow-amber-500/20 transition-all duration-500 group flex items-center uppercase tracking-widest text-sm">
                                    Explore Destinations 
                                    <i className="fas fa-arrow-right ml-4 group-hover:translate-x-2 transition-transform duration-300"></i>
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;